<template>
  <BuildingSectionCard
    title="Parking"
    :form="PropertyParkingForm"
    :has-info="Boolean(parking)"
    :placeholder="{
      title: 'No parking details yet',
      subtitle: 'Parking is the building\'s; every unit answers the same way.',
      buttonText: 'Add parking',
    }"
  >
    <template v-if="parking">
      <View v-if="parking.hasParking === false" gap="sm" align="center" data-testid="no-parking">
        <Icon name="car-01" size="small" class="icon" />
        <Text variant="body-medium">No parking available</Text>
      </View>

      <template v-else>
        <PropertyDetailsCardRows>
          <PropertyDetailsCardInfoItem label="Type" icon="car-01" :value="parking.parkingType ?? unknown" />
          <PropertyDetailsCardInfoItem label="Spaces" icon="columns-03" :value="parking.parkingAvailableSpaces ?? unknown" />
          <PropertyDetailsCardInfoItem label="Monthly charge" icon="currency-dollar-circle" :value="monthlyCharge" />
          <PropertyDetailsCardInfoItem
            v-if="parking.parkingSpacesAreTandem !== null"
            label="Tandem"
            icon="switch-horizontal-01"
            :value="parking.parkingSpacesAreTandem ? 'Yes' : 'No'"
          />
        </PropertyDetailsCardRows>
        <PropertyNotes :text="parking.parkingOtherDescription" />
      </template>
    </template>
  </BuildingSectionCard>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Icon, Text, View } from '@tallo/design-system';
import { BuildingDto, PropertyParkingForm } from '@tallo/investor/property';
import { PropertyDetailsCardInfoItem, PropertyDetailsCardRows, PropertyNotes } from '@tallo/property';

import BuildingSectionCard from '../../../components/building-section-card.vue';

/** The building's parking, answered once for every unit; a row the form left blank reads as a dash */
const props = defineProps<{ building: BuildingDto }>();

const unknown = '—';

const parking = computed(() => props.building.parking);
const monthlyCharge = computed(() => {
  const charge = parking.value?.parkingMonthlyChargePerSpace;

  return charge === null || charge === undefined ? unknown : `$${charge} per space`;
});
</script>

<style scoped lang="scss">
.icon {
  flex-shrink: 0;
  color: var(--t-color-neutral-500);
}
</style>
